// ButtonCollection.tsx
import React, { useContext, useState } from 'react';
import Button, { ButtonProps } from '@cloudscape-design/components/button';
import { UserContext } from '../../../context/authContext';

export type ButtonConfig = {
  label: string;
  buttonFunctions: () => void;
  type: 'main' | 'additional';
  variant?: ButtonProps.Variant;
  disabled?: boolean;
  wrapperText?: string;
};

type ButtonCollectionProps = {
  buttons: ButtonConfig[];
  sharedWith?: boolean;
  sharedWithArray?: string[];
};

const ButtonCollection: React.FC<ButtonCollectionProps> = ({
  buttons,
  sharedWith,
  sharedWithArray
}) => {
  const [showMore, setShowMore] = useState(false);
  const { users } = useContext(UserContext);

  const mainButtons = buttons.filter((b) => b.type === 'main');
  const additionalButtons = buttons.filter((b) => b.type === 'additional');

  const hasAdditional =
    additionalButtons.length > 0 ||
    (sharedWithArray && sharedWithArray?.length > 0);

  const renderButton = (btn: ButtonConfig) => (
    <Button
      key={btn.label}
      onClick={btn.buttonFunctions}
      variant={btn.variant}
      disabled={btn.disabled}
      ariaLabel={btn.wrapperText ?? btn.label}
    >
      {btn.label}
    </Button>
  );

  return (
    <div className="flex flex-col gap-2 w-full">
      {/* Top row: main buttons + more */}
      <div className="flex items-center gap-2 w-full">
        <div className="flex items-center gap-2 flex-wrap">
          {mainButtons.map(renderButton)}
        </div>

        {hasAdditional && (
          <div className="ml-auto">
            <Button
              ariaLabel="Show more actions"
              variant="icon"
              iconName="ellipsis"
              onClick={() => setShowMore((prev) => !prev)}
            />
          </div>
        )}
      </div>

      {/* Bottom row: additional buttons in a horizontal row */}
      {showMore && additionalButtons.length > 0 && (
        <div className="flex items-center gap-2 flex-wrap pl-0">
          {additionalButtons.map(renderButton)}
        </div>
      )}
      {/* {showMore &&
        sharedWith &&
        sharedWithArray &&
        sharedWithArray?.length > 0 && (
          <div className="rounded-xl w-full bg-white p-4">
            <p>Shared With</p>
            {sharedWithArray?.map((sub) => {
              return (
                <div>{users.filter((user) => user.sub === sub)[0].name}</div>
              );
            })}
          </div>
        )} */}
    </div>
  );
};

export default ButtonCollection;
